import React, { useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';
// eslint-disable-next-line import/no-extraneous-dependencies
import { registerField } from 'core/forms';

import { TextInput } from 'uikit/inputs';

import styles from '../styles/formFieldText.module.scss';

const FormFieldText = ({
  fieldId,
  schema: { inputProps: { type } = {}, ...schema } = {},
  updateField = () => {},
  value = '',
}) => {
  const handleBlur = useCallback(
    (event) => {
      if (!schema.onBlur) return;

      const result = schema.onBlur(event.target.value);

      if (result !== undefined && result !== event.target.value) {
        updateField(result);
      }
    },
    [schema, updateField],
  );
  return (
    <TextInput
      autoComplete={schema.autoComplete}
      autoCorrect={schema.autoCorrect}
      className={classnames(styles.element, styles[`isType${capitalize(type)}`], {
        [styles.isFullWidth]: schema.isFullWidth,
      })}
      id={fieldId}
      inputTestId={schema.testId}
      isDisabled={schema.isDisabled}
      maxLength={schema.maxLength}
      onBlur={handleBlur}
      onChange={updateField}
      onKeyDown={schema.onKeyDown}
      placeholder={schema.placeholder}
      spellCheck={schema.spellCheck}
      type={type}
      value={value ?? ''}
    />
  );
};

FormFieldText.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    autoComplete: PropTypes.oneOfType([PropTypes.oneOf(['off', 'on']), PropTypes.string]),
    autoCorrect: PropTypes.oneOf(['off', 'on']),
    inputProps: PropTypes.shape({
      type: PropTypes.string,
    }),
    isDisabled: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    maxLength: PropTypes.number,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    spellCheck: PropTypes.oneOf(['false', 'true']),
    testId: PropTypes.string,
  }),
  updateField: PropTypes.func,
  value: PropTypes.string,
};

registerField('Text', React.memo(FormFieldText));

export default FormFieldText;
